import React from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../../helpers/t";

const MultipleRecipientsDialog = ({
  handleCloseMultipleRecipientsDialog,
  toggleMultipleRecipients,
  usergroup,
  multipleRecipientList,
}) => {
  // get all users in a specifid usergroup
  const memberships = usergroup ? usergroup?.memberships : [];
  const recipientsInfoArr = multipleRecipientList ? multipleRecipientList : [];

  if (memberships !== null && memberships?.length > 0) {
    memberships.map((membership) => {
      recipientsInfoArr.push({
        customer_nbr: membership.user?.customer_nbr,
        user:
          (membership.user?.first_name !== undefined ? membership.user.first_name : "") +
          " " +
          (membership.user?.last_name !== undefined ? membership.user.last_name : ""),
        to: membership.user?.id,
        cate: membership.user?.role === "user" ? "user" : "staff",
      });
    });
  }

  return (
    <Dialog
      onClose={handleCloseMultipleRecipientsDialog}
      aria-labelledby="multiple-recipients-dialog-title"
      open={toggleMultipleRecipients}
      name="multipleRecipientsDialog"
      id="multipleRecipientsDialog"
    >
      <header className="inb-multiple-recipients-header">
        {usergroup ? (
          <a href="#" onClick={handleCloseMultipleRecipientsDialog}>
            <button
              type="button"
              id="inb-multiple-recipients-dialog-close-button"
              className="button hollow secondary right button-close-multiple-recipients-dialog round"
              title={t("close multiple recipients dialog")}
            >
              <i className="fi fi-x"></i>
            </button>
          </a>
        ) : (
          <button
            onClick={handleCloseMultipleRecipientsDialog}
            type="button"
            id="inb-multiple-recipients-dialog-close-button"
            className="button hollow secondary right button-close-multiple-recipients-dialog round"
            title={t("close multiple recipients dialog")}
          >
            <i className="fi fi-x"></i>
          </button>
        )}
        <h4>{t("users", null, "capital")}</h4>
        {recipientsInfoArr.length > 0 && (
          <div id="inb-c-main-header">
            <ul className="inb-tabs row">
              <li className="tabs-title column medium-4">{t("id")}</li>
              <li className="tabs-title column medium-4">{t("user")}</li>
            </ul>
          </div>
        )}
      </header>
      <div
        id="inb-c-main-multiple-recipients"
        className="inb-c-listing off-canvas-content"
        data-off-canvas-content=""
      >
        <>
          {recipientsInfoArr.length > 0 ? (
            recipientsInfoArr.map((recipient, index) => {
              return (
                <div className="inb-c-item inb-c-item--recipient row" key={index}>
                  <div
                    className="medium-4 small-12 column"
                    title={t("id", null, "capital")}
                    style={{ minWidth: "90px" }}
                  >
                    <span>{recipient.customer_nbr}</span>
                  </div>
                  <div
                    className="medium-4 small-12 column username"
                    title={t("recipient", null, "capital")}
                    style={{ minWidth: "90px" }}
                  >
                    <span>{recipient.user}</span>
                  </div>
                  <div
                    className="medium-4 small-12 column user-profile"
                    title={t("profile", null, "capital")}
                    style={{ minWidth: "90px", cursor: "pointer" }}
                  >
                    <a
                      href={`/users/${recipient.to}?path=/users${recipient.cate === "staff" ? "/staff" : ""}`}
                    >
                      {t("open profile")}
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-user-item">
              <div className="inb-image-box">
                <img src="assets/img/no-user.png" />
              </div>
              <h3>{t("user not found")}</h3>
              <p>{t("please add user to this group")}</p>
            </div>
          )}
        </>
      </div>
    </Dialog>
  );
};

export default MultipleRecipientsDialog;
